export default __webpack_public_path__ + "static/media/landscapeZoomedGirlIllustration.de7c6c0c.png";